// extracted by mini-css-extract-plugin
module.exports = {"root":"Spin_root__3lS8C","overlay":"Spin_overlay__3lV4b","xs":"Spin_xs__d-UkN"};